export class AccessibilityProperties {
    public description: string = "";
    public forceSimple: boolean = false;
    public name: string = "";
    public noAutoLabeling: boolean = false;
    public shortcut: string = "";
    public silent: boolean = false;
}
